<template>
<div>
  <div id="cpjsEdit" v-if="editFlag">
    <!--企业和产品介绍-->
      <div id="cpjsView" class="pt15">
        <el-row class="mb5" style="border-bottom:1px solid #463132;line-height: 29px;">
          <el-col :span="24">
            <strong style="color: #463132;">Company Information Details</strong>
          </el-col>
        </el-row>
        <el-form class="el-form demo-form-inline" ref="qyjsForm" :model="qyjsForm" label-position="right" label-width="220px" :rules="qyjsRules">
          <el-row class="tr mb5">
            <el-col :span="9">
              <el-form-item label="Company Logo" style="text-align: left" class="is-required">
                <el-upload class="avatar-uploader"
                ref="uploadLogo"
                :headers="myHeaders"
                :action="qylogoUploadAction"
                :data="upLoadLogoData"
                :on-success="logoPicSuccess"
                :before-upload="LogoChange"
                :show-file-list="false"
                accept=".jpg,.png">
                  <img v-if="qyjsForm.src!=='' && qyjsForm.src!==null" :src="qyjsForm.imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="el-upload__tip" slot="tip">jpg/png,less than 5MB</div>
                </el-upload>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="1">&nbsp;</el-col> -->
            <el-col :span="14" style="margin-left: -7%" id="qycpArea">
              <el-form-item prop="qyjj" style="text-align: left" label="Company Introduction">
                <el-input type="textarea" :rows="5" placeholder="Company Introduction" v-model="qyjsForm.qyjj" maxlength="400" :onkeyup="checkWord(qyjsForm.qyjj,'qyjsLength','400')"></el-input>
              </el-form-item>
              <el-row>
                <div class="el-upload__tip">less than
                  <span style="color: red" id="qyjsLength">{{400-qyjsForm.qyjj.length}}</span> characters</div>
              </el-row>
            </el-col>
            <el-col :span="1">&nbsp;</el-col>
          </el-row>
          <el-row class="mb5" style="border-bottom:1px solid #463132;line-height: 29px;">
            <el-col :span="12">
              <strong style="color: #463132;">Product Examples(at least 2,at most 15)</strong>
            </el-col>
            <el-col :span="12" class="pb1">
              <el-button type="primary" icon="el-icon-plus" size="small" class="r" @click="addDomain">Add Product</el-button>
            </el-col>
          </el-row>
          <el-row class="mt15 mb20" style="overflow-x: hidden">
            <el-card class="card_style" id="cp_card" v-for="(domain, index) in qyjsForm.qycpjsVOList" :key="index">
              <div slot="header" class="clearfix">
                <strong class="card_title_font">Product NO.{{index+1}}</strong>
                <el-button type="danger" icon="el-icon-minus" size="small" @click.prevent="removeDomain(domain)" class="r" style="margin: 4px -15px 0px 0px">Del Product</el-button>
              </div>
              <el-row class="tr">
                <el-col :span="10">
                  <el-form-item label="Product Photo" style="text-align: left" class="is-required">
                    <el-upload class="avatar-uploader"
                    ref="uploadCpPics"
                    :headers="myHeaders"
                    :action="cptpUploadAction"
                    :on-success="cpjsPicSuccess"
                    :before-upload="CpPicsChange"
                    :show-file-list="false"
                    :data="CpjsUpLoadData"
                    accept=".jpg,.png">
                      <img @click="getIndex(index,domain.src)" v-if="domain.src!=='' && domain.src!==null" :src="domain.imageUrl" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon" @click="getIndex(index)"></i>
                      <div class="el-upload__tip" slot="tip">jpg/png,less than 5MB</div>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="14" style="margin-left: -10%">
                  <el-row>
                    <el-form-item label="Category of the Product" class="is-required" :prop="'qycpjsVOList.' + index + '.cplx'" :rules="qyjsRules.cplx">
                      <el-cascader :options="cpssfl_data" :props="defaultProps" size="small" v-model="domain.cplx" placeholder="Category of the Product" class="searchSelect" clearable :show-all-levels="false"></el-cascader>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <div class="el-upload__tip"></div>
                  </el-row>
                  <el-row id="cpjsArea">
                    <el-form-item label="Product Introduction" :prop="'qycpjsVOList.' + index + '.cpjj'" :rules="qyjsRules.cpjj">
                      <el-input type="textarea" :rows="2" placeholder="Product Introduction" v-model="domain.cpjj" maxlength="500" :onkeyup="checkWord(domain.cpjj,index+100,'500')"></el-input>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <div class="el-upload__tip">less than
                      <span style="color: red" :id="index+100">{{500-domain.cpjj.length}}</span> characters</div>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
          </el-row>
        </el-form>
        <el-row class="buttonSubmit">
          <el-col :span="24">
            <el-button v-if="qyjsData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">Cancel</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitCpjs('qyjsForm')">Save</el-button>
          </el-col>
        </el-row>
      </div>
  </div>

  <div class="main-container" element-loading-text="loading" v-if="!editFlag">
    <div id="qycpjs" class="mb5">
        <el-row class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="10">
            <strong  class="vt">Company Logo：</strong>
            <img v-if="qyjsData.imageUrl!==''" :src="qyjsData.imageUrl" @click="imgPreview(qyjsData.imageUrl)" style="max-width:100%;max-height:140px;" class="poi">
            <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
          </el-col>
          <el-col :span="11">
            <strong >Company Introduction：</strong>
            <span  v-text="qyjsData.qyjj||'no'"></span>
            <br>
          </el-col>
          <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">Edit</el-button>
            </el-col>
        </el-row>
        <el-row class="mb10">
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="22">
            <el-row class="mb10">
              <strong>Product Introduction：</strong>
            </el-row>
            <el-form id="cpjs" v-if="cpjsData.length>0" :inline="true" style="width: 100%;" class="demo-form-inline">
              <el-form-item v-for="(cpjs,index) in cpjsData" style="width: 49%;" :key="index">
                <el-card class="mb10 card_style" id="cpjsImg">
                  <el-row class="h100">
                    <el-col :span="5" class="h100 tc">
                      <img v-if="cpjs.imageUrl!==''" :src="cpjs.imageUrl" class="poi" @click="imgPreview(cpjs.imageUrl)">
                      <div v-else style="width:100px;" class="iconfont icon-noPic"></div>
                    </el-col>
                    <el-col :span="19" style="line-height: 24px;" class="pl15">
                      <strong>Category of the Product：</strong>
                      <span v-text="cpjs.cplxmc_ENG||'no'"></span>
                      <br>
                      <strong>Product Introduction：</strong>
                      <span v-text="cpjs.cpjj||'no'"></span>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form-item>
            </el-form>
            <span v-else>no product</span>
          </el-col>
        </el-row>
      </div>

    <!--图片预览-->
      <el-dialog id="previewImgDialog" :visible.sync="showPicVisible" :close-on-click-modal="false" size="tiny">
        <img :src="previewImg" width="100%" class="mt15">
      </el-dialog>
  </div>

</div>
</template>

<script>
import secureImageMixin from '@/common/js/secureImageMixin'
export default {
  mixins: [secureImageMixin],
  props:{
    qyid: {
        type: String,
        required: true
    },
  },
  name: "cpjsEdit",
  data() {
    return {
      baseUrl: window.config.baseUrl,
      myHeaders: { XTOKEN: localStorage.getItem("XTOKEN") },
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      cptpUploadAction: window.config.domain+'/qycpjs/upload',
      qylogoUploadAction: window.config.domain+'/qyjs/upload',
      
      //产品所属分类
      cpssfl_data: [],
      //产品index
      index: 0,
      //产品图片上传参数
      CpjsUpLoadData: {
        qyid: ""
      },
      //上传logo加参数
      upLoadLogoData: {
        uuid: "",
        qyid: ""
      },
      //公司logo
      imageUrl: "",
      //要删除的图片路径list
      delPicList: [],
      delPicSrc: "",
      //上传后未保存的图片list
      unsavedPicList: [],
      //上传图片Data
      fileList: [],
      //上传加参数
      upLoadData: {
        qyid: ""
      },
      
      //企业介绍表单
      qyjsForm: {
        qyid: "",
        qyjj: "",
        qycpjsVOList: [
          {
            qyid: "",
            src: "",
            cplx: [],
            cpjj: ""
          }
        ],
        src: "",
        imageUrl: "",
        reserve1: ""
      },
      qyjsRules: {
        qyjj: [
          {
            required: true,
            message: "Company Introduction is required",
            trigger: "blur"
          },
          //{ pattern: /^[\da-zA-Z !?|<>.,;:'"@#$￥=+_—%^&*()\[\]{}\\\/~`-]*$/, message: 'Characters and number and symbol only',trigger: 'blur' },
          /*
          {
            pattern: /^[\da-zA-Z \!\?\r\n\|\<\>\.\,\，\;\:\'\"\@\#\$\￥\=\+\_\—\%\^\&\*\(\)\（\）\[\]\{\}\\\/\~\`\-\。\·\…\！\、\“\”\‘\’\《\》\<\>\【\】\：\；\？]*$/,
            message: "Characters and number only",
            trigger: "blur"
          },*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 400,
            message: "Less than 400 characters",
            trigger: "blur"
          }
        ],
        cplx: [
          {
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error("Category of the Product is required"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        cpjj: [
          {
            required: true,
            message: "Product Introduction is required",
            trigger: "blur"
          },
          /*
          {
            pattern: /^[\da-zA-Z \!\?\r\n\|\<\>\.\,\，\;\:\'\"\@\#\$\￥\=\+\_\—\%\^\&\*\(\)\（\）\[\]\{\}\\\/\~\`\-\。\·\…\！\、\“\”\‘\’\《\》\<\>\【\】\：\；\？]*$/,
            message: "Characters and number only",
            trigger: "blur"
          }*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' }
        ]
      },
     
      //树结构配置
      defaultProps: {
        children: "children",
        label: "codeName",
        value: "codeValue"
      },
      cpjsStatus: 0,

      editFlag: false,
      //企业介绍
      qyjsData: {
        logoBase64: "",
        qyjj: ""
      },
      //产品介绍
      cpjsData: [],
      previewImg: "",
      showPicVisible: false,
      //产品所属分类
      cpssfl_data: [],
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
        if (this.qyjsForm.qycpjsVOList.length == 0) {
              this.qyjsForm.qycpjsVOList.push({
                qyid: this.qyid,
                cplx: [],
                cpjj: "",
                cpjj_eng: "",
                src: "",
                imageUrl: "",
                key: Date.now()
              });
            }
      }else if(this.qyid != ''){
        this.findQyjsByQyid(this.qyid);
      }
    }
  },
  created: function() {
    this.getCpssfl(); //产品所属分类
  },
  methods: {
    //根据代码集获取产品所属分类
    getCpssfl: function() {
      let vm = this;
      vm.$axios.get("/codelist/getZycpTree/CPLX_EN").then(
        function(res) {
          vm.cpssfl_data = res.data.result;
        }.bind(vm),
        function(error) {
          console.log(error);
        }
      );
    },
    //通过企业id查找企业和产品介绍
    findQyjsByQyid: function(qyid) {
      let vm = this;
      vm.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qyjs/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            this.qyjsData = JSON.parse(JSON.stringify(res.data.result[0]));
            this.qyjsData.imageUrl =
              vm.baseUrl + "/upload/" + this.qyjsData.src;
            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
            }else{
                vm.editFlag = true;
            }
            vm.cpjsStatus = 1; //修改
            var resultForm = res.data.result[0];
            var params = {
              qyid: qyid,
              deleteFlag: "N"
            };
            vm.$axios.post("/qycpjs/list", params).then(
              function(res) {
                this.cpjsData = JSON.parse(JSON.stringify(res.data.result));
                for (var i in this.cpjsData) {
                  this.cpjsData[i].imageUrl =
                    vm.baseUrl + "/upload/" + this.cpjsData[i].src;
                }

                var result = res.data.result;
                var qycpjsList = [];
                for (var i in result) {
                  var cplxArray = [];
                  if(result[i].cplx){
                    cplxArray.push(result[i].cplx.substr(0, 1) + "000");
                    cplxArray.push(result[i].cplx.substr(0, 2) + "00");
                    cplxArray.push(result[i].cplx);
                  }
                  qycpjsList.push({
                    uuid: result[i].uuid,
                    qyid: result[i].qyid,
                    cpjj: result[i].cpjj,
                    cpjj_eng: result[i].cpjj_eng,
                    cplx: cplxArray,
                    src: result[i].src,
                    imageUrl: vm.baseUrl + "/upload/" + result[i].src
                  });
                }
                resultForm.qycpjsVOList = qycpjsList;
                vm.qyjsForm = resultForm;
                vm.qyjsForm.imageUrl = vm.baseUrl + "/upload/" + vm.qyjsForm.src;

                vm.$emit("getLoading", false);
              }.bind(vm),
              function(error) {
                vm.$emit("getLoading", false);
                console.log(error);
              }
            );
            vm.CpjsUpLoadData.qyid = vm.qyid;
            vm.upLoadLogoData.qyid = vm.qyid;
          } else {
            vm.editFlag = true;
            vm.cpjsStatus = 0; //新增
            vm.CpjsUpLoadData.qyid = vm.qyid;
            vm.upLoadLogoData.qyid = vm.qyid;
            if (vm.qyjsForm.qycpjsVOList.length == 0) {
              vm.qyjsForm.qycpjsVOList.push({
                qyid: vm.qyid,
                cplx: [],
                cpjj: "",
                cpjj_eng: "",
                src: "",
                imageUrl: "",
                key: Date.now()
              });
            }
            vm.$emit("getLoading", false);
          }
        }.bind(vm),
        function(error) {
          vm.$emit("getLoading", false);
          console.log(error);
        }
      );
    },
    //产品图片上传成功回调方法
    cpjsPicSuccess: function(res, file) {
      this.qyjsForm.qycpjsVOList[this.index].src = res.src;
      this.setLocalImage(this.qyjsForm.qycpjsVOList[this.index], 'imageUrl', file.raw);
    //  this.unsavedPicList.push(res.src);
    },
    logoPicSuccess: function(res, file) {
      this.qyjsForm.src = res.src;
      this.setLocalImage(this.qyjsForm, 'imageUrl', file.raw);
    //  this.unsavedPicList.push(res.src);
    },
    //企业logochange
    LogoChange: function(file, fileList) {
      var fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      var fileNameLength = file.name.length; //取到文件名长度
      var fileFormat = file.name.substring(fileName + 1, fileNameLength);
      const isPng = fileFormat.toLowerCase() == "png";
      const isJpg = fileFormat.toLowerCase() == "jpg";
      const isLt1M = file.size / 1024 / 1024 < 5;
      if (!isPng && !isJpg) {
        this.$message.error("Picture has to be endswith png or jpg");
      } else if (!isLt1M) {
        this.$message.error("Picture has to be less than 5MB!");
      } else {
        this.delPicList.push(this.qyjsForm.src);
      }
      return isLt1M && (isPng||isJpg);
    },
   
    //产品图片change
    CpPicsChange: function(file, fileList) {
      var fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      var fileNameLength = file.name.length; //取到文件名长度
      var fileFormat = file.name.substring(fileName + 1, fileNameLength);
      const isPng = fileFormat.toLowerCase() == "png";
      const isJpg = fileFormat.toLowerCase() == "jpg";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isPng && !isJpg) {
        this.$message.error("Picture has to be endswith png or jpg");
      } else if (!isLt2M) {
        this.$message.error("Picture has to be less than 5MB!");
      } else {
        this.delPicList.push(this.delPicSrc);
      }
      return isLt2M && (isPng||isJpg);
    },
    //获取点击上传的产品图片位于第几个card，用于赋src值
    getIndex: function(index, src) {
      this.index = index;
      if (src != null && src != undefined && src != "") {
        //this.delPicList.push(src);
        this.delPicSrc = src;
      }
    },
    //新增产品card
    addDomain: function() {
      //判断最后一个card产品信息是否填全
      var cp = this.qyjsForm.qycpjsVOList[
        this.qyjsForm.qycpjsVOList.length - 1
      ];
      if (cp.cplx == "" || cp.cpjj == "" || cp.src == "") {
        // this.$message({
        //   message: "请完整填写产品信息中的全部内容",
        //   type: "warning"
        // });
        this.$alert('Please fill out the Product Examples form', 'warning', {
          confirmButtonText: 'ok',
          type: 'warning'
        });
        return false;
      } else {
        if (this.qyjsForm.qycpjsVOList.length < 15) {
          this.qyjsForm.qycpjsVOList.push({
            qyid: this.qyid,
            cplx: [],
            cpjj: "",
            cpjj_eng: "",
            src: "",
            imageUrl: "",
            key: Date.now()
          });
        } else {
         
          this.$alert('Not more than 15 product examples', 'warning', {
            confirmButtonText: 'ok',
            type: 'warning'
          });
        }
      }
    },
    //删除产品card
    removeDomain: function(item) {
      if (this.qyjsForm.qycpjsVOList.length > 2) {
        var index = this.qyjsForm.qycpjsVOList.indexOf(item);
        if (index !== -1) {
          if (
            this.qyjsForm.qycpjsVOList[index].src != "" &&
            this.qyjsForm.qycpjsVOList[index].src != null &&
            this.qyjsForm.qycpjsVOList[index].src != undefined
          ) {
            this.delPicList.push(this.qyjsForm.qycpjsVOList[index].src);
          }
          this.qyjsForm.qycpjsVOList.splice(index, 1);
        }
      } else {
        this.$alert('At least 2 product examples', 'warning', {
          confirmButtonText: 'ok',
          type: 'warning'
        });
      }
    },
    //产品介绍提交（下一步）
    submitCpjs: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("Failed to save. Please fill in the Brief Information before filling in other information", 'Info', {
          confirmButtonText: 'ok'
        });
      }else{
        vm.$refs[formName].validate(valid => {
        if (valid) {
          //判断最后一个card产品信息是否填全
          var cp = vm.qyjsForm.qycpjsVOList[vm.qyjsForm.qycpjsVOList.length - 1];
          var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
          if ( vm.qyjsForm.imageUrl == null || vm.qyjsForm.imageUrl == "") {
            //判断企业logo是否上传
            this.$alert('Please upload your Company Logo', 'warning', {
              confirmButtonText: 'ok',
              type: 'warning'
            });
            console.log("error submit!!");
            return false;
          } else if (cp.cplx == "" || cp.cpjj == "" || cp.src == "") {
            this.$alert('Please fill out the Product Examples form', 'warning', {
              confirmButtonText: 'ok',
              type: 'warning'
            });
            return false;
          } else if (reg.test(cp.cpjj)) {
            vm.$message({
              message: "Unable to input Chinese",
              type: "warning"
            });
            vm.loading = false;
            return false;
          }else if (vm.qyjsForm.qycpjsVOList.length < 2) {
            this.$alert('At least 2 product examples', 'warning', {
              confirmButtonText: 'ok',
              type: 'warning'
            });
              console.log("error submit!!");
              return false;
          }
          else {
            //信息填写完整
            var tempList = [];
            for (var i in vm.qyjsForm.qycpjsVOList) {
              var cpjj_temp = vm.qyjsForm.qycpjsVOList[i].cpjj;
              //产品类型级联下拉处理
              if (
                typeof vm.qyjsForm.qycpjsVOList[i].cplx == "object" &&
                vm.qyjsForm.qycpjsVOList[i].cplx.constructor == Array &&
                vm.qyjsForm.qycpjsVOList[i].cplx.length > 0
              ) {
                var length = vm.qyjsForm.qycpjsVOList[i].cplx.length;
                var cplx_temp = vm.qyjsForm.qycpjsVOList[i].cplx[length - 1];
              }
              var obj_temp = {
                uuid: vm.qyjsForm.qycpjsVOList[i].uuid,
                qyid: vm.qyid,
                src: vm.qyjsForm.qycpjsVOList[i].src,
                cplx: cplx_temp,
                cpjj: cpjj_temp
              };
              tempList.push(obj_temp);
            }
            if (vm.cpjsStatus == 0) {
              //新增
              vm.$emit("getLoading", true);
              var params = {
                qyid: vm.qyid,
                qyjj: vm.qyjsForm.qyjj,
                qycpjsVOList: tempList,
                deleteFlag: "N",
                src: vm.qyjsForm.src,
                cjrid: vm.currentUser.userid,
                cjrmc: vm.currentUser.username,
                validateFlag: 'T'
              };
              vm.$axios.post("/qyjs/doInsertByVo", params).then(
                function(res) {
                  if (res.data.result != null && res.data.result != "") {
                   
                    vm.$message({
                      message: "Company Information Details and Product Examples has been saved!",
                      type: "success"
                    });
                    vm.$emit("getLoading", false);
                   // this.$emit("getActive",  5);
                   vm.editFlag = false;
                   this.findQyjsByQyid(this.qyid);
                   
                    vm.cpjsStatus = 1;
                    
                    vm.unsavedPicList = [];
                  } else {
                    vm.$message({
                      message: "Company Information Details and Product Examples save failed",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  vm.$emit("getLoading", false);
                  console.log(error);
                }
              );
            } else {
              //修改
              vm.$emit("getLoading", true);
              var params = {
                uuid: vm.qyjsForm.uuid,
                qyid: vm.qyid,
                src: vm.qyjsForm.src,
                qyjj: vm.qyjsForm.qyjj,
                qycpjsVOList: tempList,
                xgrid: vm.currentUser.userid,
                xgrmc: vm.currentUser.username,
                validateFlag: 'T'
              };
              vm.$axios.post("/qyjs/doUpdateQyCpByVO", params).then(
                function(res) {
                  if (res.data.result != null && res.data.result != "") {
                   
                    vm.$message({
                      message: "Company Information Details and Product Examples has been saved!",
                      type: "success"
                    });
                    vm.$emit("getLoading", false);
                  //  this.$emit("getActive",  5);
                    vm.editFlag = false;
                    this.findQyjsByQyid(this.qyid);

                    vm.cpjsStatus = 1;
                    vm.unsavedPicList = [];
                  } else {
                    vm.$message({
                      message: "Company Information Details and Product Examples save failed",
                      type: "error"
                    });
                    vm.$emit("getLoading", false);
                  }
                }.bind(vm),
                function(error) {
                  vm.$emit("getLoading", false);
                  console.log(error);
                }
              );
            }
          }
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
   
      }
       },
    
    //产品介绍上一步
    cancelCpjs: function() {
      this.$emit("getActive",  3);
      // let vm = this;
      // vm.delPicList = [];
      // if (vm.unsavedPicList.length > 0) {
      //   vm.$axios.post("/qycpjs/delPic", vm.unsavedPicList).then(
      //     function(res) {
      //       vm.unsavedPicList = [];
      //     }.bind(vm),
      //     function(error) {
      //       console.log(error);
      //     }
      //   );
      // }
    },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findQyjsByQyid(this.qyid);
    },
    imgPreview: function(val) {
      this.previewImg = val;
      this.showPicVisible = true;
    },
 
  }
};
</script>

<style lang="scss">
#cpjsEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  #cpjsArea .el-form-item__error {
    padding-top: 1px;
  }
  #qycpArea .el-form-item__error {
    padding-top: 1px !important;
  }
  #cp_card .el-card__header {
    padding: 1px 15px;
  }
  #cplx_btn_group {
    margin-bottom: 10px;
  }
  #cplx_btn_group .el-button--small {
    margin-right: 10px;
  }
  #cplx_btn_group .el-button + .el-button {
    margin-left: 0;
  }
  #cplx_chb_group .el-checkbox {
    margin-right: 30px;
  }
  #cplx_chb_group .el-checkbox + .el-checkbox {
    margin-left: 0;
  }
  #cplx_btn_group .el-form-item__error {
    padding-top: 8px;
  }
  
}
  #cpjs .el-form-item__content {
    width: 100% !important;
  }
  #cpjsImg img {
    max-height: 100%;
    max-width: 100%;
  }
  #cpjs .el-form-item:nth-child(even) {
    margin-right: 0;
  }
</style>


// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Cpjs.vue